import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';

import AccountPanel from './AccountPanel';
import {BaseCard} from '../../../components/wizard';
import { extendedstyles } from '../../appstyles';

const s:any ={
  root: {
    width: '100%',
    display: 'flex',
    // overflow: 'scroll',
    justifyContent: 'space-between'
  },
  panel: {
    flex: '1 1 auto'
  },
};

class AccountCard extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.props.deb.log("AccountCard");
    this.state = {
      next: true,
      idtype: null,
      idfrom: null,
      fwopen: false
    };
  }

  render = () => {
    const { classes, theme, ...extraProps  } = this.props;
    const {record,data,extras,setItem} = this.props;
    const {photo,idcard} = data.start;
    return (
      <BaseCard
        cardid={'ACOUNT'}
        cardname={'Account'}
        cardtitle={'Account Information'}
        instruction={'Provide service account information of the customer'}
        step={2}
        buttons={['START','CANCEL','PREV','NEXT','GUIDE']}
        {...extraProps}
      >
        <AccountPanel 
          data={extraProps.data}
          record={record}
          extras={extras}
          photo={photo} 
          idcard={idcard}
          setItem={setItem}
          />
      </BaseCard>
    );
  }
}

AccountCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default AccountCard;
